import React from 'react';
import { PortalContext } from '../../../../context/PortalContext';
import { actionRedirect } from '../../../../helpers/common-helpers';
import { formatOwnership } from '../../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';

export const useCitaHandler = () => {
	const { portalService, userInteractionService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();
	const userVehicles = portalService.getPersonVehicles().getValue();

	const handleCita = () => {
		trackingManager.trackClubVWButtonClick(
			'Open lead cita renovadores 1015',
			{ contentId: 'Open lead cita renovadores 1015' },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		actionRedirect(userInteractionService, 'es-oneform--lead-cita');
	};
	return { handleCita };
};
